import React from "react";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const NotificationWrapper = ({ children }) => {
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={2500}
        newestOnTop
        closeOnClick
        pauseOnHover
        transition={Slide}
      />
      {children}
    </>
  );
};

export default NotificationWrapper;
